import Org from "./Org";

export default function OrgIndex() {
  return (
    <>
      <Org />
    </>
  );
}
